export default "__VITE_ASSET__jXqjjPWF__"